import BlogPreview from '../components/BlogPreview'
import FullWidthImageContainer from '../components/FullWidthImageContainer'
import Layout from '../components/Layout'
// import PropTypes from 'prop-types'
import React from 'react'

export default class IndexPage extends React.Component {
  render() {
    const pin = {
      imageUrl: '/img/principle/coffee_story_1.jpg',
      title: 'Blending after pre-roasting',
      description:
        'Caffe Bene strives to deliver an exceptional taste of coffee. The technique of Caffe Bene for roasting and blending is allowing each of the beans in the blend roast to a profile that could magnify the characteristics and flavours of the beans from different origins.',
    }

    const blogs = [
      {
        imageUrl: '/img/principle/coffee_story_2.jpg',
        title: 'Farm-to-table system',
        description:
          'Caffe Bene has the perfect FTT (Farm to Table) system. We have signed the contract with IPANEMA farm as the largest single coffee farm in Brazil.',
      },
      {
        imageUrl: '/img/principle/coffee_story_3.jpg',
        title: 'Medium roasting',
        description:
          'After the beans are pre-roasted and blended to bring out the origin flavour coffee beans from different origins, then we use medium roasting to creates a balance between acidity and body of the coffee.',
      },
      {
        imageUrl: '/img/principle/coffee_story_4.jpg',
        title: 'Clean and safe coffee',
        description:
          'Caffe Bene coffee bean has undergone 13 types of processes, from harvesting to sorting and roasting beans and 4 types of sorting operations for foreign objects to ensure the coffee quality control so that customer could enjoy our coffee safely. Caffe Bene has a roasting plant in Korea with HACCP, ISO and HALAL certification.',
      },
      {
        imageUrl: '/img/principle/coffee_story_5.jpg',
        title: 'Roast Master Assistant System',
        description:
          'We have implemented RMA, Roast Master Assistant system to record thoroughly during all production processes of Caffé Bene beans. The recorded data can be utilized for quality management to achieve better-tasting beans.',
      },
    ]

    return (
      <Layout>
        <FullWidthImageContainer
          imageUrl="/img/principle/banner_1.jpg"
          title="Principle added to coffee bean"
          description="Raw coffee beans grow in respectively different places such as Ethiopia, Columbia, Brazil, Papua New Guinea. Since the coffee beans of Caffé Bene were roasted separately according to the features of raw beans, they have rich flavour and fragrance. When such rich flavor and aroma blended in optimum ratios, the best-class espresso of Caffé Bene completed."
        />

        <div className="section">
          <div className="container">
            <div class="has-text-centered">
              <h1 className="title mg-btm-2 brand-color">
                Roasting Plant Story
              </h1>
            </div>

            <img
              className="full-w"
              src="/img/principle/plant_story.jpg"
              alt=""
            ></img>
          </div>
        </div>

        <div className="has-background-white-bis section">
          <div className="container">
            <div class="has-text-centered">
              <h1 className="title is-marginless brand-color">
                Caffe Bene Story
              </h1>
            </div>

            <div class="columns is-multiline mg-top-2">
              <BlogPreview
                className="column is-8"
                title={pin.title}
                imageUrl={pin.imageUrl}
                description={pin.description}
              />
              {blogs.map(item => (
                <BlogPreview
                  className="column is-4"
                  title={item.title}
                  imageUrl={item.imageUrl}
                  description={item.description}
                  key={item.title}
                />
              ))}
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
